import styled from 'styled-components';
import { Row } from 'components/Base/Grid';

export const SRow = styled(Row)`
  background-color: ${({ theme }) => theme.colorWhitePrimary};
  z-index: 99;
`;
